<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">追加閲覧可能グループ管理</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="loading != 2" class="text-center">
              <a-spin tip="Loading..." />
            </div>
            <a-form-model
              v-if="loading == 2"
              ref="ruleForm"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-form-model-item label="閲覧可能グループ">
                <a-checkbox-group
                  v-model="readGroups"
                  :options="allGroups"
                />
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" @click="onSubmit">
                  更新
                </a-button>
                <router-link :to="backPath">
                  <a-button style="margin-left: 10px;">
                    戻る
                  </a-button>
                </router-link>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'FormUser',
  data() {
    return {
      loading: 0,
      allGroups: [],
      readGroups: [],
      backPath: '/users/' + this.$route.params.id,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    }
  },
  methods: {
    onSubmit() {
      const _this = this
      const send = Vue.prototype.$api.send('put', 'user/' + _this.$route.params.id + '/user_read_range', { groups: this.readGroups })
      send.then(response => {
        console.log(response)
        _this.$notification['success']({
          message: '更新しました。',
        })
        _this.$router.push(this.backPath)
      })
        .catch(error => {
          this.$notification['error']({
            message: error.status + ': 更新に失敗しました。',
          })
        })
    },
  },
  created() {
    const resultUserGruops = Vue.prototype.$api.send('get', 'user/' + this.$route.params.id + '/user_read_range')
    resultUserGruops.then(response => {
      this.loading++
      this.readGroups = response.map((item) => { return item.id })
    })
      .catch(error => {
        this.$notification['error']({
          message: error.status + ': 追加閲覧可能グループの取得に失敗しました。',
        })
        this.loading++
      })
    const resultAllGroups = Vue.prototype.$api.send('get', 'groups')
    resultAllGroups.then(response => {
      this.loading++
      this.allGroups = response.map((item) => { return { label: item.name, value: item.id } })
    })
      .catch(error => {
        this.$notification['error']({
          message: error.status + ': グループの取得に失敗しました。',
        })
        this.loading++
      })
  },
}

</script>
